import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { executeOnSingleOrMultiple, isInArray } from "tsparticles-engine";
import { CircleShape } from "./Shapes/Circle/CircleShape";
import { Emitter } from "./Options/Classes/Emitter";
import { Emitters } from "./Emitters";
import { ShapeManager } from "./ShapeManager";
import { SquareShape } from "./Shapes/Square/SquareShape";
var EmittersPlugin = /*#__PURE__*/function () {
  function EmittersPlugin(engine) {
    _classCallCheck(this, EmittersPlugin);
    this._engine = engine;
    this.id = "emitters";
  }
  _createClass(EmittersPlugin, [{
    key: "getPlugin",
    value: function getPlugin(container) {
      return new Emitters(this._engine, container);
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(options, source) {
      var _a, _b, _c, _d, _e, _f;
      if (!this.needsPlugin(options) && !this.needsPlugin(source)) {
        return;
      }
      if (source === null || source === void 0 ? void 0 : source.emitters) {
        options.emitters = executeOnSingleOrMultiple(source.emitters, function (emitter) {
          var tmp = new Emitter();
          tmp.load(emitter);
          return tmp;
        });
      }
      var interactivityEmitters = (_b = (_a = source === null || source === void 0 ? void 0 : source.interactivity) === null || _a === void 0 ? void 0 : _a.modes) === null || _b === void 0 ? void 0 : _b.emitters;
      if (interactivityEmitters) {
        if (interactivityEmitters instanceof Array) {
          options.interactivity.modes.emitters = {
            random: {
              count: 1,
              enable: true
            },
            value: interactivityEmitters.map(function (s) {
              var tmp = new Emitter();
              tmp.load(s);
              return tmp;
            })
          };
        } else {
          var emitterMode = interactivityEmitters;
          if (emitterMode.value !== undefined) {
            if (emitterMode.value instanceof Array) {
              options.interactivity.modes.emitters = {
                random: {
                  count: (_c = emitterMode.random.count) !== null && _c !== void 0 ? _c : 1,
                  enable: (_d = emitterMode.random.enable) !== null && _d !== void 0 ? _d : false
                },
                value: emitterMode.value.map(function (s) {
                  var tmp = new Emitter();
                  tmp.load(s);
                  return tmp;
                })
              };
            } else {
              var tmp = new Emitter();
              tmp.load(emitterMode.value);
              options.interactivity.modes.emitters = {
                random: {
                  count: (_e = emitterMode.random.count) !== null && _e !== void 0 ? _e : 1,
                  enable: (_f = emitterMode.random.enable) !== null && _f !== void 0 ? _f : false
                },
                value: tmp
              };
            }
          } else {
            var emitterOptions = options.interactivity.modes.emitters = {
              random: {
                count: 1,
                enable: false
              },
              value: new Emitter()
            };
            emitterOptions.value.load(interactivityEmitters);
          }
        }
      }
    }
  }, {
    key: "needsPlugin",
    value: function needsPlugin(options) {
      var _a, _b, _c;
      if (!options) {
        return false;
      }
      var emitters = options.emitters;
      return emitters instanceof Array && !!emitters.length || emitters !== undefined || !!((_c = (_b = (_a = options.interactivity) === null || _a === void 0 ? void 0 : _a.events) === null || _b === void 0 ? void 0 : _b.onClick) === null || _c === void 0 ? void 0 : _c.mode) && isInArray("emitter", options.interactivity.events.onClick.mode);
    }
  }]);
  return EmittersPlugin;
}();
export function loadEmittersPlugin(_x) {
  return _loadEmittersPlugin.apply(this, arguments);
}
function _loadEmittersPlugin() {
  _loadEmittersPlugin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(engine) {
    var plugin;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!engine.emitterShapeManager) {
              engine.emitterShapeManager = new ShapeManager(engine);
            }
            if (!engine.addEmitterShape) {
              engine.addEmitterShape = function (name, shape) {
                var _a;
                (_a = engine.emitterShapeManager) === null || _a === void 0 ? void 0 : _a.addShape(name, shape);
              };
            }
            plugin = new EmittersPlugin(engine);
            _context.next = 5;
            return engine.addPlugin(plugin);
          case 5:
            engine.addEmitterShape("circle", new CircleShape());
            engine.addEmitterShape("square", new SquareShape());
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadEmittersPlugin.apply(this, arguments);
}
export * from "./EmitterContainer";
export * from "./EmittersEngine";
export * from "./Enums/EmitterClickMode";
export * from "./Enums/EmitterShapeType";